import { api as apiProvider } from '@/core/api/';

const baseApiURL = 'api/report';

export const getReport = (batchLoadControlId, academicYearId, monthNumber) =>
  apiProvider.get(`${baseApiURL}/findings`, {
    params: {
      batchLoadControlId,
      academicYearId,
      peiAnalysisServiceId: null,
      monthNumber,
      regionId: null,
      studentSieId: null,
    },
  });

export const getReportRefundHandling = (params) =>
  apiProvider.get(`${baseApiURL}/refundhandling`, {
    params: {
      ...params,
    },
  });
